import { Col, Row } from 'reactstrap'
import { useAuth } from '../../../../../hooks/useAuth'
import { Globe, Shield } from 'react-feather'
import { useTranslation } from 'react-i18next'

const ProfileFollower = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  // Mapear código de idioma a nombre completo
  const languageMap: { [key: string]: string } = {
    "ES": "Español",
    "EN": "English",
    "FR": "Français",
    "PT": "Português",
  };

  const userLanguage = user?.language ? languageMap[user.language] || user.language : t("No especificado");
  const userRole = user?.role?.name || t("Usuario");

  return (
    <div className="follow">
      <Row>
        <Col xs="6" className="text-md-end border-right">
          <div className="follow-num d-flex align-items-center justify-content-md-end justify-content-center gap-2">
            <Globe size={20} />
            <div>
              <div className="fw-bold">{userLanguage}</div>
              <span className="text-muted small">{t("Idioma")}</span>
            </div>
          </div>
        </Col>
        <Col xs="6" className="text-md-start">
          <div className="follow-num d-flex align-items-center justify-content-md-start justify-content-center gap-2">
            <Shield size={20} />
            <div>
              <div className="fw-bold">{userRole}</div>
              <span className="text-muted small">{t("Rol")}</span>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default ProfileFollower